import "jquery/dist/jquery.min.js"
import "jquery-bridget/jquery-bridget.js"
import "sticky-sidebar/dist/sticky-sidebar.min.js"
import "resize-sensor/ResizeSensor.min.js"
import "bootstrap/js/scrollspy.js"


import Form from './inc/form-errors.js';
import FormSubmitter from './inc/form-submitter';
import '../less/form-extension.less';


const commons = {
    setMenuMobile: function () {
        $('.hamburger-menu').on('click', function () {
            $(this).toggleClass('open');
            $('.bar').toggleClass('animate');
            if ($(this).hasClass('open')) {
                $('#menu').addClass('open');
                $('#masthead').addClass('open');
            } else {
                $('#menu').removeClass('open');
                $('#masthead').removeClass('open');
            }
        });
        $('#menu li a').on('click', function () {
            $('#masthead').removeClass('open');
            $('#menu').removeClass('open');
            $('.hamburger-menu').removeClass('open');
            $('.bar').removeClass('animate');
        });
    },

    setFooterMenu: function () {
        $('body').scrollspy({ target: '#menu-vertical', offset: 500 });
        if (window.location.hash)
            scroll(0, 0);
        setTimeout(function () {
            scroll(0, 0);
        }, 1);

        $('body[data-page="about"] .footer-menu-about a').each(function () {
            let attr = $(this).attr('data-anchor');

            if ($(this).data("anchor")) {
                $(this).on('click', function () {
                    $(this).attr('href', '#' + attr);
                    $('html, body').stop().animate({
                        scrollTop: $($(this).attr('href')).offset().top -120
                    }, 600);
                    return false;
                });
            }
        });

        $('body[data-page="governance"] .footer-menu-governance a').each(function () {
            let attr = $(this).attr('data-anchor');

            if ($(this).data("anchor")) {
                $(this).on('click', function () {
                    $(this).attr('href', '#' + attr);
                    $('html, body').stop().animate({
                        scrollTop: $($(this).attr('href')).offset().top -120
                    }, 600);
                    return false;
                });
            } else {

            }
        });

        if (window.location.hash) {
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top -120
            }, 600, 'swing');

        }
    },


    setVerticalMenu: function () {
        if (window.matchMedia("(max-width: 1023px)").matches) {
            menuVmobile();
        } else {
            menuVdesktop();
            $(window).on('load resize orientationchange', function () {
                menuVdesktop();
            });
        }

        function menuVdesktop(){
            //var myMarginLeft= $("#masthead .container").css("marginLeft");
            //$('#menu-vertical').css('left', myMarginLeft);

            $('#menu-vertical a').on('click', function(){
                //Animate
                $('html, body').stop().animate({
                    scrollTop: $( $(this).attr('href') ).offset().top - 120
                }, 300);
                return false;
            });

            let headerH = $('.content-header').outerHeight(true);
            let mastheadH = $('#masthead').outerHeight(true);
            let gapTitle = 105; // allineamnto menu con voci titoli

            $('body').scrollspy({ target: '#menu-vertical', offset: 504 });

            $('#menu-vertical').affix({
                offset: {
                    top: (headerH + mastheadH) - gapTitle,
                    bottom: ($('#footer').outerHeight(true)) + 90
                }
            });
        }


        function menuVmobile(){
            $(".btn-menu-v").on('click', function () {
                $("#menu-vertical").toggleClass('open');
            });

            $("#menu-vertical a").on('click', function () {
                $("#menu-vertical").removeClass('open');
            });

            $('#menu-vertical a').on('click', function(){
                //Toggle Class
                $(".active").removeClass("active");
                $(this).closest('li').addClass("active");
                var theClass = $(this).attr("class");
                $('.'+theClass).parent('li').addClass('active');
                //Animate
                $('html, body').stop().animate({
                    scrollTop: $( $(this).attr('href') ).offset().top - 100
                }, 300);
                return false;
            });

            $('#menu-vertical').affix({
                offset: {
                    top:50,
                    bottom: 1481
                }
            })
        }
    },

    setFullBg: function () {
        $(".fullBg").each(function () {
            let attr = $(this).attr('data-image-src');

            if (typeof attr !== typeof undefined && attr !== false) {
                $(this).css('background-image', 'url(' + attr + ')');

            }

        });
    },
    
    setTabs: function () {

       $(".cm-tabs-nav a:first").addClass("current");
        $('.cm-tabs-nav a').click(function (e) {
            e.preventDefault();
            let _href = $(this).attr("href");
            $(".cm-tabs-nav a").removeClass("current");
            $(this).addClass("current");
            $(".cm-tabs-content > .cm-tabs-item").hide().removeClass('current');
            $(_href).fadeIn().addClass("current");
        });
    },



  preventDownloadBtn: function () {

        let openModalBtn =   $('.open-modal');
        let acceptBtn = $('.btn-modal-accept');
        let refusetBtn = $('.btn-modal-refuse');
        let modalPanel = $('.modal-conditions');
        let downloadDest;
        let downloadBtn;

         openModalBtn.bind('touchstart touchmove touchend mousedown click mouseup select',function(e){
            e.preventDefault()
          }).on('click', function(){
           downloadBtn = $(this);
            $('body').addClass('modal-open');
           modalPanel.fadeIn();
           downloadDest = $(this).attr('href')
         });

        acceptBtn.on('click', function(){
              downloadBtn.unbind('touchstart touchmove touchend mousedown click mouseup select');
              $('body').removeClass('modal-open');
              modalPanel.fadeOut();
              window.location = downloadDest;
        });

        refusetBtn.on('click', function(){
          $('body').removeClass('modal-open');
          modalPanel.fadeOut();
        });
  },



	setBtnEmail: function () {
		$('a[data-econtact]').each(function(){
			let firstpart = $(this).data('econtact');
			let domain = '@'+$(this).data('domain');
			let email = firstpart + domain;
			$(this).html(email);
			$(this).on('click',  () => {
				$(this).attr('href', 'mailto:' + email);
			});
		});
	},
  setContactForm: function () {

    let formFooter = new FormSubmitter({
      formSelector : '#contact-form',
      triggerSelector : '#contact-form input[type="submit"]',
      type : 'post'
    });

    Form.fieldsListener('#contact-form');
  },

};


export default commons;








// WEBPACK FOOTER //
// ./src/js/commons.js